import Vue from 'vue';

const SET_MENUS = 'SET_MENUS';
const SET_MENU = 'SET_MENU';
const UNSET_MENU = 'UNSET_MENU';

export default {
  namespaced: true,
  state: {
    menus: null,
    menu: null,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [SET_MENUS](state, menus) {
      state.menus = menus;
    },
    [SET_MENU](state, menu) {
      state.menu = menu;
    },
    [UNSET_MENU](state) {
      state.menu = null;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    getMenus({ commit }, { page }) {
      return Vue.axios.get('menus', {
        params: { page },
      }).then(({ data }) => commit(SET_MENUS, data));
    },
    getMenu({ commit }, id) {
      return Vue.axios.get(`menus/${id}`)
        .then(({ data }) => commit(SET_MENU, data));
    },
    unsetMenu({ commit }) {
      commit(SET_MENU);
    },
    saveMenu({ commit }, data) {
      const { id } = data;
      const method = id ? 'put' : 'post';
      const url = id ? `menus/${id}` : 'menus';

      return Vue.axios({
        method,
        url,
        data,
      }).then((response) => {
        commit(SET_MENU, response.data);
        return new Promise(resolve => resolve(response.data));
      });
    },
    saveMenuMeta(context, { id, params }) {
      return Vue.axios.put(`menus/${id}/meta`, params);
    },
    deleteMenu(context, id) {
      return Vue.axios.delete(`menus/${id}`);
    },
  },
  getters: {
    menus: state => state.menus,
    menu: state => state.menu,
  },
};
